import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import ContactViewModel from "@/models/ContactViewModel";
import { ref } from "@vue/composition-api";

export default function (options?: { captainEmail?: string; autoLoadContacts?: boolean }) {
    const captainEmail = options && options.captainEmail ? options.captainEmail.toLowerCase() : undefined;
    const contacts = ref<Array<ContactViewModel>>([]);

    const getContacts = async (): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve) => {
            Axios.get("/api/contact")
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        contacts.value = result.data;
                    }
                    resolve();
                })
                .catch((error) => {
                    console.log(error);
                    resolve();
                });
        });
    };

    if (options?.autoLoadContacts) {
        getContacts();
    }

    const statusFromError = (error: any): number => {
        return error && error.response && error.response.status ? error.response.status : 0;
    };

    const add = async (contact: ContactViewModel): Promise<number> => {
        await defineHeaderAxios();
        return new Promise((resolve) => {
            Axios.post("/api/contact", contact)
                .then((result: AxiosResponse) => {
                    resolve(result.status);
                })
                .catch((error) => {
                    console.log(error);
                    resolve(statusFromError(error));
                });
        });
    };

    const update = async (contact: ContactViewModel): Promise<number> => {
        await defineHeaderAxios();
        return new Promise((resolve) => {
            Axios.put(`/api/contact/${contact.id}`, contact)
                .then((result: AxiosResponse) => {
                    resolve(result.status);
                })
                .catch((error) => {
                    console.log(error);
                    resolve(statusFromError(error));
                });
        });
    };

    const remove = async (id: number): Promise<number> => {
        await defineHeaderAxios();
        return new Promise((resolve) => {
            Axios.delete(`/api/contact/${id}`)
                .then((result: AxiosResponse) => {
                    resolve(result.status);
                })
                .catch((error) => {
                    console.log(error);
                    resolve(statusFromError(error));
                });
        });
    };

    const get = async (id: number): Promise<ContactViewModel> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.get(`/api/contact/${id}`)
                .then((result: AxiosResponse<ContactViewModel>) => {
                    if (result.status === 200) {
                        resolve(result.data);
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };

    const getCaptain = async (deviceId: string): Promise<ContactViewModel> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.get(`/api/contact/${deviceId}`)
                .then((result: AxiosResponse<ContactViewModel>) => {
                    if (result.status === 200) {
                        resolve(result.data);
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };

    const nameRules: ((v: any) => any)[] = [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 30) || "Name must be less than 30 characters",
    ];

    const emailRules: ((v: any) => any)[] = [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        (v) =>
            !captainEmail || v.toLowerCase() !== captainEmail ||
            "This email belongs to the captain and cannot be used",
    ];

    return {
        contacts,
        getContacts,
        add,
        update,
        remove,
        get,
        getCaptain,
        nameRules,
        emailRules,
    };
}
